import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const fightingStyleModule = namespace('fightingStyles');
let CharactersFightingStyles = class CharactersFightingStyles extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Fighting Styles';
    }
    created() {
        this.fetchFightingStyles();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.fightingStyles)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(fightingStyle => ({
            ...fightingStyle,
            id: fightingStyle.name,
            isExpandable: fightingStyle.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    fightingStyleModule.State
], CharactersFightingStyles.prototype, "fightingStyles", void 0);
__decorate([
    fightingStyleModule.Action
], CharactersFightingStyles.prototype, "fetchFightingStyles", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersFightingStyles.prototype, "isInHandbook", void 0);
CharactersFightingStyles = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersFightingStyles);
export default CharactersFightingStyles;
